// extracted by mini-css-extract-plugin
module.exports = {"add_description_form":"add_description_form--t4paT","Inf_border_img":"Inf_border_img--2r08z","description_textArea":"description_textArea--1qsas"};